module.exports = __webpack_public_path__ + "img/madeInGermany@2x.4faff19.jpg";